import { request, requestV2 } from "./index";

// 购买商品分析权益
const fetchAnalysis = async <T>(reqData: unknown) => {
  return requestV2<T>({
    method: "post",
    url: "/product/analysis",
    data: reqData,
  });
};

// 获取视频脚本结果
const fetchVideoScript = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/aiTask/video/getVideoScript",
    data: reqData,
  });
};

// 导出视频脚本
const downloadVideoScriptAnalysis = async (reqData: unknown) => {
  return request({
    method: "post",
    url: "/api/download/video/script-analysis",
    data: reqData,
    responseType: "blob",
  });
};

// 脚本生成-导出视频脚本
const downloadVideoScriptGenerate = async (reqData: unknown) => {
  return request({
    method: "post",
    url: "/api/download/video/script-generate",
    data: reqData,
    responseType: "blob",
  });
};

// 获取视频脚本仿写结果
const fetchVideoScripteMulation = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/aiTask/video/videoScripteMulation",
    data: reqData,
  });
};

// ai轮询
const startAITask = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/aiTask/startAiTask",
    data: reqData,
  });
};

const fetchVideoHistoryProduct = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/video/detail/stat/queryProductList",
    data: reqData,
  });
};

// new api
// 获取视频链接预览
const fetchVideoLinkPreview = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/api/video/link-preview",
    data: reqData,
  });
};

// 获取视频URL
const fetchVideoURL = async (reqData: unknown) => {
  return request<{ url: string }>({
    method: "get",
    url: "/api/video/video-url",
    params: reqData,
  });
};

// 发起视频脚本解析（轮询）
const startScriptAnlysisTask = async <T>(reqData: unknown, params: { country: string }) => {
  return request<T>({
    method: "post",
    url: "/api/video/script-analysis",
    data: reqData,
    params,
  });
};

// 获取视频脚本解析结果
const fetchScriptAnlysisResult = async <T>(reqData: unknown) => {
  return request<T>({
    method: "get",
    url: "/api/video/script-analysis",
    params: reqData,
  });
};

// 发起视频卖点提取（轮询）
const fetchSellingPointsTask = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/api/product/attribute",
    data: reqData,
  });
};

// 获取商品卖点轮询
const fetchSellingPointsResult = async <T>(reqData: unknown) => {
  return request<T>({
    method: "get",
    url: "/api/product/attribute",
    params: reqData,
  });
};

// 获取视频脚本生成结果
const fetchScriptGenerationResult = async <T>(reqData: unknown) => {
  return request<T>({
    method: "get",
    url: "/api/video/script-generate",
    params: reqData,
  });
};

// 获取随机视频
const fetchExampleVideo = async <T>() => {
  return request<T>({
    method: "get",
    url: "/api/video/try-example",
  });
};

// 获取视频信息
const fetchVideoDetail = async <T>(reqData: unknown) => {
  return request<T>({
    method: "get",
    url: "/api/video/detail",
    params: reqData,
  });
};

// 获取商品信息
const fetchProductInfo = async <T>(reqData: unknown) => {
  return request<T>({
    method: "get",
    url: "/api/video/product-info",
    params: reqData,
  });
};

// 搜索商品
const fetchProductSearch = async (reqData: unknown) => {
  return request({
    method: "get",
    url: "/api/product/keyword-search",
    params: reqData,
  });
};

// 查询 AI 权益
const fetchCheckAiUse = async (reqData: { id: string; type: string }) => {
  return requestV2<{ used: boolean; progressInfo: { remain: number } }>({
    method: "get",
    url: "/api/credits/check-consumed",
    params: reqData,
  });
};

// 获取视频收藏状态
const fetchVideoCollection = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/api/users/collection/status",
    params: reqData,
  });
};

const fetchAiCredits = async <T>() => {
  return request<T>({
    method: "get",
    url: "/api/credits/balance",
  });
};

export default {
  fetchAnalysis,
  startAITask,
  fetchVideoScript,
  fetchVideoScripteMulation,
  fetchVideoHistoryProduct,

  // new api
  fetchVideoLinkPreview,
  fetchVideoURL,
  fetchExampleVideo,
  startScriptAnlysisTask,
  fetchScriptAnlysisResult,
  fetchSellingPointsTask,
  fetchSellingPointsResult,
  fetchScriptGenerationResult,
  fetchProductSearch,
  fetchVideoDetail,
  fetchProductInfo,
  downloadVideoScriptAnalysis,
  downloadVideoScriptGenerate,
  fetchCheckAiUse,
  fetchVideoCollection,
  fetchAiCredits,
};
